import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import BadgeNewLarge from '../icons/BadgeNewLarge.js';
import { BADGE_TYPE } from '../../constants/global.js';
import styles from './IconText.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function IconText(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    isSelected = _ref.isSelected,
    badge = _ref.badge,
    href = _ref.href,
    onClick = _ref.onClick;
  function handleClick(event) {
    event.preventDefault();
    onClick === null || onClick === void 0 || onClick(event);
    location.href = href;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    className: cx('article', {
      'is-selected': isSelected
    }),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('icon')
  }, /*#__PURE__*/React.createElement("div", null, isSelected ? icon.enabled : icon.disabled), badge && ( /*#__PURE__*/React.createElement("span", {
    className: cx('badge', {
      'type-new': badge === BADGE_TYPE.NEW
    })
  }, badge === BADGE_TYPE.NEW && /*#__PURE__*/React.createElement(BadgeNewLarge, {
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uC2E0\uADDC")))), text, isSelected && /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD604\uC7AC \uD398\uC774\uC9C0"));
}

export { IconText as default };
